import styled from 'styled-components'

export const ErrorMessageContainer = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: center;
  gap: 24px;
`

export const ButtonContainer = styled.section`
  margin-top: auto;
`
